module.exports = __webpack_public_path__ + "img/lock-cancel.06197d07.svg";